import { IProductGroups } from "@domain/version2/ProductGroups"
import apiClient from "@util/ApiClient"
import { AxiosResponse } from "axios"

export default class ProductGroupsApi {
    static getProductGroups(params: { keyword: string }): Promise<AxiosResponse<IProductGroups[]>> {
        return apiClient.get(`product-groups/autocomplete`, { params })
    }
}
